module.exports = __webpack_public_path__ + "static/media/7-7.4a45d8bd.mp3";